import { useNavigate } from "@tanstack/react-router";
import type { ButtonConfig } from "@/components/common/Complete";
import { diaryHomeToDoPath } from "@/features/diaries/routes";
import { useAuth } from "../../../utils/auth";
import { useDiariesByPatientQuery } from "../api";

const useNavigateToDiary = () => {
    const navigate = useNavigate();

    const auth = useAuth();
    const patientId = auth && typeof auth.id === "string" ? auth.id : null;
    const { data: diaries = [] } = useDiariesByPatientQuery(patientId ?? "");
    const diaryWord = diaries.length === 1 ? "Diary" : "Diaries";
    const firstDiary = diaries?.[0];
    const diaryRoute: ButtonConfig =
        diaries.length === 1 && firstDiary?.diary_id
            ? {
                  text: diaryWord,
                  to: diaryHomeToDoPath,
                  params: { diaryId: firstDiary.diary_id },
              }
            : { text: diaryWord, to: "/diaries" };

    const navigateToDiary = () => {
        void navigate(diaryRoute);
    };
    return {
        diaryWord: diaries.length === 1 ? "Diary" : "Diaries",
        diaryRoute,
        navigateToDiary,
    };
};

export default useNavigateToDiary;
